<template>
    <input
        class="form-control"
        :id="id"
        @input="e => $emit('input', e.target.value)"
        :name="name"
        type="text"
        :value="value"
    >
</template>

<script>
export default {
    name: 'TextInput',

    props: {
        id: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String,
        },
        value: {
            required: true,
            type: String,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Forms/InputFields/TextInput.vue